// extracted by mini-css-extract-plugin
export default {"textSeo":"xo2B8","textSeoTitle":"zfqfM"};